// extracted by mini-css-extract-plugin
export default {"knockedDown":"guardians-sheet_knockedDown__i2PTa","dead":"guardians-sheet_dead__L-Cei","deadBlock":"guardians-sheet_deadBlock__TtbZk"};